import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';

export const GET_STRIPE_CUSTOMER_REQUEST = 'GET_STRIPE_CUSTOMER_REQUEST';
export const GET_STRIPE_CUSTOMER_SUCCESS = 'GET_STRIPE_CUSTOMER_SUCCESS';
export const GET_STRIPE_CUSTOMER_FAILURE = 'GET_STRIPE_CUSTOMER_FAILURE';
export const GET_CUSTOMER_INVOICES = 'GET_CUSTOMER_INVOICES';
export const GET_CUSTOMER_INVOICES_SUCCESS = 'GET_CUSTOMER_INVOICES_SUCCESS';
export const GET_CUSTOMER_INVOICES_REQUEST = 'GET_CUSTOMER_INVOICES_REQUEST';
export const GET_CUSTOMER_INVOICES_FAILURE = 'GET_CUSTOMER_INVOICES_FAILURE';
export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
export const UPDATE_STRIPE_TOKEN_REQUEST = 'UPDATE_STRIPE_TOKEN_REQUEST';
export const UPDATE_STRIPE_TOKEN_SUCCESS = 'UPDATE_STRIPE_TOKEN_SUCCESS';
export const UPDATE_STRIPE_TOKEN_FAILURE = 'UPDATE_STRIPE_TOKEN_FAILURE';
export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE';
export const BUY_DAC_REQUEST = 'BUY_DAC_REQUEST';
export const BUY_DAC_SUCCESS = 'BUY_DAC_SUCCESS';
export const BUY_DAC_FAILURE = 'BUY_DAC_FAILURE';

export function CreateToken(stripetoken) {
  return {
    stripetoken,
    type: CREATE_TOKEN_SUCCESS,
  };
}

export function GetToken() {
  return {
    type: GET_TOKEN_SUCCESS,
  };
}

export function beUpdateStripeToken(stripetoken, salonId) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ stripetoken }),
  };

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `billing/salon/${salonId}/add/payment/`,
      authenticated: true,
      params: { stripetoken },
      types: [UPDATE_STRIPE_TOKEN_REQUEST, UPDATE_STRIPE_TOKEN_SUCCESS, UPDATE_STRIPE_TOKEN_FAILURE],
      config,
    },
  };
}

export function beGetStripeCustomer(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `billing/salon/${salonId}/add/payment/`,
      authenticated: true,
      types: [GET_STRIPE_CUSTOMER_REQUEST, GET_STRIPE_CUSTOMER_SUCCESS, GET_STRIPE_CUSTOMER_FAILURE],
    },
  };
}

export function GetCustomerInvoices(salonId, params = {}) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `billing/salon/${salonId}/invoices/?${fromObjectToQueryString(params)}`,
      authenticated: true,
      types: [GET_CUSTOMER_INVOICES_REQUEST, GET_CUSTOMER_INVOICES_SUCCESS, GET_CUSTOMER_INVOICES_FAILURE],
    },
  };
}

export function getBillingPlans(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: 'billing/plans/',
      authenticated: true,
      types: [GET_PLANS_REQUEST, GET_PLANS_SUCCESS, GET_PLANS_FAILURE],
      params: { method: 'GET', salonId },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}
